import { render, staticRenderFns } from "./CreateHistoria.vue?vue&type=template&id=bc6f6c24"
import script from "./CreateHistoria.vue?vue&type=script&lang=js"
export * from "./CreateHistoria.vue?vue&type=script&lang=js"
import style0 from "./CreateHistoria.vue?vue&type=style&index=0&id=bc6f6c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports